import { Component, Input, Output, ViewChild, EventEmitter, SimpleChanges, OnInit } from '@angular/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
// import { TABLE_HEADER, CLICK_EVENT } from 'src/app/Interfaces/generic-ngx-data-table.interface';


export interface TABLE_CONFIG {
  actionButtons?: ACTION_BUTTONS;
}

export interface ACTION_BUTTONS {
  ShowActionButtonDivCondition?: string;
  view?: string;
  edit?: string;
  delete?: string;
}

export interface TABLE_HEADER {
  key: string;
  datatype: 'date' | 'number' | 'string';
  label: string,
  minWidth?: number,
  resizeable?: boolean;
  sortable?: boolean;
  draggable?: boolean;
  canAutoResize?: boolean;
}

export interface CLICK_EVENT {
  row: any;
  tableData: any[];
  rowIndex: number;
  colIndex?: number;
  eventRow: any;
  eventType: 'dblclick' | 'sclick' | 'keydown';
}


@Component({
  selector: 'generic-ngx-data-table',
  templateUrl: './generic-ngx-data-table.component.html',
  styleUrls: ['./generic-ngx-data-table.component.scss']
})
export class GenericNgxDataTableComponent implements OnInit {

  private tableDataBackup: any = [];
  @Input() tableData: any[] = [];
  @Input() tableHeader: TABLE_HEADER[] = [];
  @Input() tableConfig: any = {};

  @Output() doubleClickEvent: EventEmitter<CLICK_EVENT> = new EventEmitter<CLICK_EVENT>();
  @Output() singleClickEvent: EventEmitter<CLICK_EVENT> = new EventEmitter<CLICK_EVENT>();
  @Output() editClickEvent: EventEmitter<CLICK_EVENT> = new EventEmitter<CLICK_EVENT>();
  @Output() deleteClickEvent: EventEmitter<CLICK_EVENT> = new EventEmitter<CLICK_EVENT>();

  

  public tableHeaderLength: number = 0;
  public currentHoverIndex: number = -1;

  @ViewChild(DatatableComponent) table: DatatableComponent | any;

  ColumnMode = ColumnMode;

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    this.tableHeaderLength = this.tableHeader.length - 1;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.tableHeaderLength = this.tableHeader.length - 1;
    this.tableDataBackup = [...this.tableData];
  }

  ngOnDestroy() {
  }

  getTableHeaderKeysToSearch = () => {
    const tblHeaderKeys: any[] = Object.keys(this.tableDataBackup[0]);
    return tblHeaderKeys;
  }

  updateFilter(event: any) {
    const val = event.target.value.toString().toLowerCase().trim();
    const headerKeys = this.getTableHeaderKeysToSearch();

    const temp = this.tableDataBackup.filter((d: any) => {
      // for (let i = 0; i < headerKeys.length; i++) {
        return d.name.toString().toLowerCase().indexOf(val) !== -1 || !val
        // return ((d[headerKeys[i]] && d[headerKeys[i]].toString().toLowerCase().indexOf(val) !== -1) || !val)
      // }
    })
    console.log(temp);


    // filter our data


    // update the rows
    this.tableData = temp;
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

  onSelect(event: any) {
    // console.log('Select Event', event);
  }

  onActivate = (event: any) => {
    // console.log('Activate Event', event.type);
    if (event.type == 'mouseenter') {
      this.currentHoverIndex = event?.row?.srno ?? -1;
      // this.currentHoverIndex = event?.row?.srno;
    }
    if (event.type == 'dblclick') {
      const rowIndex = event?.row?.srno;
      this.doubleClickEvent.emit({
        eventRow: event?.row,
        eventType: event.type,
        tableData: this.tableData, rowIndex: rowIndex,
        row: this.tableData[rowIndex]
      });
    }
  }
  getMouseLeave() {
    this.currentHoverIndex = -1;
  }

  getRowClass = (row: any) => {
    // console.log(row,'row',row?.srno, this.currentHoverIndex);
    // this.currentHoverIndex = row?.srno;

    return {
      'vio-row-highlight': row?.srno == this.currentHoverIndex
    };
  }

  getCellClass = ({ row, column, value }: any): any => {
    return {};
    console.log('getCellClass', column, row);

    if (this.tableHeaderLength == column) {

    }
    return {
      'is-female': value === 'female'
    };
  }
  vieWClick(row: any, rowIndex: number, colIndex: number) {
    this.singleCLick(row, rowIndex, colIndex);
  }
  editClick(row: any, rowIndex: number, colIndex: number) {
    this.editClickEvent.emit({
      eventRow: row,
      eventType: 'sclick',
      tableData: this.tableData,
      rowIndex: rowIndex,
      colIndex,
      row: this.tableData[rowIndex]
    });
  }
  deleteClick(row: any, rowIndex: number, colIndex: number) {
    this.deleteClickEvent.emit({
      eventRow: row,
      eventType: 'sclick',
      tableData: this.tableData,
      rowIndex: rowIndex,
      colIndex,
      row: this.tableData[rowIndex]
    });
  }

  singleCLick(row: any, rowIndex: number, colIndex: number = -1) {
    // console.log("singleCLick", row, rowIndex, colIndex);

    this.singleClickEvent.emit({
      eventRow: row,
      eventType: 'sclick',
      tableData: this.tableData,
      rowIndex: rowIndex,
      colIndex,
      row: this.tableData[rowIndex]
    });
  }

  showHideActionDiv(row: any, srno: number, colIndex: number) {
    const showCondition = this.tableConfig?.actionButtons?.ShowActionButtonDivCondition ? eval(this.tableConfig?.actionButtons?.ShowActionButtonDivCondition) : true;
    return (showCondition && this.currentHoverIndex == srno && colIndex == 0)
  }

  showHideActionsButtons(row: any, action: string) {
    const showCondition = this.tableConfig?.actionButtons[action] ? eval(this.tableConfig?.actionButtons[action]) : true;
    return showCondition;
  }

}
